'use strict';

import template from './join_form.html';

const LOCAL_STORAGE_KEY = 'hasEmailLogin';
const controller = [
  'localStorage',

  function (localStorage) {
    this.isNewUser = (localStorage.get(LOCAL_STORAGE_KEY) !== 'true');

    this.close = function () {
      localStorage.set(LOCAL_STORAGE_KEY, true);
      this.done();
    };
  }
];
var saJoinForm = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&'
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saJoinForm;



// WEBPACK FOOTER //
// ./app/src/modules/join/join_form.component.js